/* eslint-disable import/no-anonymous-default-export */

import otorrinolaringologia1 from '../assets/congresos/Otorrinolaringologia/img1.jpg';
import otorrinolaringologia2 from '../assets/congresos/Otorrinolaringologia/img2.jpg';
import otorrinolaringologia3 from '../assets/congresos/Otorrinolaringologia/img3.jpg';
import otorrinolaringologia4 from '../assets/congresos/Otorrinolaringologia/img4.jpg';

import asma1 from '../assets/congresos/asma/img1.jpg';
import asma2 from '../assets/congresos/asma/img2.jpg';
import asma3 from '../assets/congresos/asma/img3.jpg';
import asma4 from '../assets/congresos/asma/img4.jpg';

import medicina1 from '../assets/congresos/medicina/img1.jpg';
import medicina2 from '../assets/congresos/medicina/img2.jpg';
import medicina3 from '../assets/congresos/medicina/img3.jpg';
import medicina4 from '../assets/congresos/medicina/img4.jpg';

import neumonologia1 from '../assets/congresos/neumonologia/img1.jpg';
import neumonologia2 from '../assets/congresos/neumonologia/img2.jpg';
import neumonologia3 from '../assets/congresos/neumonologia/img3.jpg';
import neumonologia4 from '../assets/congresos/neumonologia/img4.jpg';

import Puericultura1 from '../assets/congresos/Puericultura/img1.jpg';
import Puericultura2 from '../assets/congresos/Puericultura/img2.jpg';
import Puericultura3 from '../assets/congresos/Puericultura/img3.jpg';
import Puericultura4 from '../assets/congresos/Puericultura/img4.jpg';

export const congresosData = {
  otorrinolaringologia: {
    id: 'otorrinolaringologia',
    titulo: 'XXXIII Congreso Venezolano',
    subtitulo: 'de Otorrinolaringología',
    descripcion:
      'BioMercy presente en el Congreso Venezolano de Otorrinolaringología, acompañando a los especialistas que cuidan la audición, la voz y la respiración de miles de venezolanos. ¡Seguimos sumando confianza, ciencia y cercanía!',
    descripcion2: '',
    imagenes: [
      {
        id: 1,
        src: otorrinolaringologia1,
        alt: 'Grupo de doctores en congreso',
        className: 'congreso-img1',
      },
      {
        id: 2,
        src: otorrinolaringologia2,
        alt: 'Doctores en evento médico',
        className: 'congreso-img2',
      },
      {
        id: 3,
        src: otorrinolaringologia3,
        alt: 'Equipo médico en congreso',
        className: 'congreso-img3',
      },
      {
        id: 4,
        src: otorrinolaringologia4,
        alt: 'Profesionales de la salud',
        className: 'congreso-img4',
      },
    ],
    botones: [
      {
        id: 1,
        texto: 'otorrinolaringologia',
        posicion: 'superior',
        className: 'congreso-btn1',
      },
    ],
  },
  asma: {
    id: 'Asma',
    titulo: 'XXXII Congreso Venezolano',
    subtitulo: 'de Asma, Alergia e Inmunología',
    descripcion:
      'En BioMercy estamos al lado de quienes combaten las enfermedades respiratorias y alérgicas cada día. Participamos con pasión para que más pacientes respiren con tranquilidad.',
    descripcion2: '',
    imagenes: [
      {
        id: 1,
        src: asma1,
        alt: 'asma',
        className: 'congreso-img1',
      },
      {
        id: 2,
        src: asma2,
        alt: 'asma',
        className: 'congreso-img2',
      },
      {
        id: 3,
        src: asma3,
        alt: 'asma',
        className: 'congreso-img3',
      },
      {
        id: 4,
        src: asma4,
        alt: 'asma',
        className: 'congreso-img4',
      },
    ],
  },
  medicina: {
    id: 'Medicina',
    titulo: 'XXVIII Congreso Venezolano',
    subtitulo: 'de Medicina Interna',
    descripcion:
      'Conectando con los médicos internistas de Venezuela para seguir fortaleciendo nuestro compromiso con la salud integral. BioMercy, donde los especialistas están, ahí estamos nosotros.',
    descripcion2: '',
    imagenes: [
      {
        id: 1,
        src: medicina1,
        alt: 'medicina',
        className: 'congreso-img1',
      },
      {
        id: 2,
        src: medicina2,
        alt: 'medicina',
        className: 'congreso-img2',
      },
      {
        id: 3,
        src: medicina3,
        alt: 'medicina',
        className: 'congreso-img3',
      },
      {
        id: 4,
        src: medicina4,
        alt: 'medicina',
        className: 'congreso-img4',
      },
    ],
  },
  neumonologia: {
    id: 'neumonologia',
    titulo: 'XXXII y XXXIII Congreso Venezolano',
    subtitulo: 'de Neumonología y Cirugía de Tórax',
    descripcion:
      'Respirar bien es vivir mejor. Por eso, en BioMercy nos enorgullece estar junto a los especialistas que cuidan la salud respiratoria del país.',
    descripcion2: '',
    imagenes: [
      {
        id: 1,
        src: neumonologia1,
        alt: 'neumonologia',
        className: 'congreso-img1',
      },
      {
        id: 2,
        src: neumonologia2,
        alt: 'neumonologia',
        className: 'congreso-img2',
      },
      {
        id: 3,
        src: neumonologia3,
        alt: 'neumonologia',
        className: 'congreso-img3',
      },
      {
        id: 4,
        src: neumonologia4,
        alt: 'neumonologia',
        className: 'congreso-img4',
      },
    ],
  },
  puericultura: {
    id: 'puericultura',
    titulo: 'Congreso Venezolano',
    subtitulo: 'de Puericultura y Pediatría',
    descripcion:
      'BioMercy dijo presente en uno de los espacios más importantes dedicados a la salud infantil. Seguimos trabajando para acompañar a los pediatras en su labor y contribuir al bienestar de las familias venezolanas.',
    descripcion2: '',
    imagenes: [
      {
        id: 1,
        src: Puericultura1,
        alt: 'Puericultura y Pediatría',
        className: 'congreso-img1',
      },
      {
        id: 2,
        src: Puericultura2,
        alt: 'Puericultura y Pediatría',
        className: 'congreso-img2',
      },
      {
        id: 3,
        src: Puericultura3,
        alt: 'Puericultura y Pediatría',
        className: 'congreso-img3',
      },
      {
        id: 4,
        src: Puericultura4,
        alt: 'Puericultura y Pediatría',
        className: 'congreso-img4',
      },
    ],
  },
};

export default { congresosData };
